import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import Select from "react-select";
import * as yup from "yup";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import CancelModal from "./CancelModal";
import { useContacts } from "../../state/ContactContext";

const AddExistingContactDrawer = ({ showDrawer, handleClose }) => {
  const { addExistingContact } = useContacts();
  const [cancelOpen, setCancelOpen] = useState(false);

  const contactTypeOptions = [
    { label: "Regular and emergency", value: ["regular", "emergency"] },
    { label: "Regular", value: ["regular"] },
    { label: "Emergency", value: ["emergency"] },
  ];

  const schema = yup.object().shape({
    email: yup.string().email("Enter a valid email.").required("Enter email."),
    contactTypes: yup.mixed().required("Select contact type."),
  });

  const initialValues = {
    email: "",
    contactTypes: [],
  };

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      const error = await addExistingContact({
        email: values.email,
        contactTypes: values.contactTypes,
      });

      if (error) {
        formik.setFieldError("email", error);
        return;
      }

      handleClose();
      formik.resetForm({ values: initialValues });
    },
  });

  useEffect(() => {
    if (!showDrawer) {
      formik.resetForm({ values: initialValues });
    }
  }, [showDrawer]);

  if (!showDrawer) {return null;}

  return (
    <div className={`page-drawer-modal ${showDrawer && "show-drawer"}`}>
      <CancelModal
        cancelOpen={cancelOpen}
        handleCancelClose={() => setCancelOpen(false)}
        handleLeave={() => {
          setCancelOpen(false);
          handleClose();
        }}
        modalTitle="Leave without saving?"
        modalDescription="You’ll lose any changes you made."
      />

      <div className="page-drawer-container">
        <div className="pd-header">
          <h4>Add Existing Contact</h4>
        </div>
        <div className="pd-content">
          <h6 className="form-title">Add Existing Contact</h6>
          <form onSubmit={formik.handleSubmit} className="inline-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <div className="input-grp">
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <small className="text-danger">{formik.errors.email}</small>
                )}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="contactTypes">
                <Tooltip title="Regular contacts can be contacted by your client once, emergency contacts are repeatedly contacted until someone responds.">
                  <InfoIcon />
                </Tooltip>
                Contact Type
              </label>

              <Select
                name="contactTypes"
                options={contactTypeOptions}
                className="form-control select-field"
                classNamePrefix="select"
                placeholder="Select contact type"
                value={contactTypeOptions.find((opt) =>
                  opt.value.every((val) =>
                    formik.values.contactTypes.includes(val),
                  ),
                )}
                onChange={(option) =>
                  formik.setFieldValue("contactTypes", option.value)
                }
                onBlur={() => formik.setFieldTouched("contactTypes", true)}
              />
            </div>

            <div className="pd-footer">
              <div className="filter-btns-group">
                <button
                  type="button"
                  onClick={() => {
                    if (formik.dirty) {setCancelOpen(true);}
                    else {handleClose();}
                  }}
                >
                  Cancel
                </button>
                <button type="submit">Add Contact</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddExistingContactDrawer;
